import { agencyId, Dtos, suretyAccountId, userId } from "@inrev/common";
import type { Path } from "react-hook-form";
import { z } from "zod";
import { getSchemaDefaults } from "../../../../utils/form";

const CreateQuote = Dtos.Admin.SuretyQuote.Create.Request;

// This flow has no minimal-mode UI — project.description is the only identifier ever collected.
const requiredDescriptionAdminProjectSchema = CreateQuote.adminBidQuoteSchema.shape.project.extend({
	// nullish input keeps form defaults compatible; pipe output is hard-required for asterisk derivation.
	description: z.string().nullish().pipe(z.string().trim().min(1, "Required")),
});

const adminQuoteSchemaWithRequiredDescription = z.discriminatedUnion("contractSuretyType", [
	z.object({
		...CreateQuote.adminBidQuoteSchema.shape,
		project: requiredDescriptionAdminProjectSchema,
	}),
	z.object({
		...CreateQuote.adminFinalQuoteSchema.shape,
		project: requiredDescriptionAdminProjectSchema,
	}),
	z.object({
		...CreateQuote.adminBidToFinalQuoteSchema.shape,
		project: requiredDescriptionAdminProjectSchema,
	}),
]);

export const adminBondRequestFormSchema = z.object({
	suretyAccountId: suretyAccountId,
	agencyId: agencyId,
	agentId: userId,
	underwriterId: userId,
	followers: z
		.array(userId, { error: "At least one follower is required" })
		.min(1, "At least one follower is required"),
	quote: adminQuoteSchemaWithRequiredDescription,
	bondTerms: CreateQuote.optionalBondTermsSchema,
});

export type AdminBondRequestFormData = z.infer<typeof adminBondRequestFormSchema>;

export const fp = (path: Path<AdminBondRequestFormData>): string => path;

export const getDefaultAdminBondRequestFormData = (): AdminBondRequestFormData => {
	const defaults = getSchemaDefaults(adminBondRequestFormSchema);
	defaults.quote.suretyType = "contract";
	return defaults;
};
